export default __webpack_public_path__ + "static/media/excellentEmoji.63566ecd.svg";